function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from "react";
import { Popover, Button, Tooltip, Icon } from "@blueprintjs/core";
import classnames from "classnames";
import "./style.css";
import { popoverOverflowModifiers } from "..";

var InfoHelper = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InfoHelper, _Component);

  function InfoHelper() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = InfoHelper.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        content = _this$props.content,
        children = _this$props.children,
        _this$props$icon = _this$props.icon,
        icon = _this$props$icon === void 0 ? "info-sign" : _this$props$icon,
        isPopover = _this$props.isPopover,
        isButton = _this$props.isButton,
        size = _this$props.size,
        isInline = _this$props.isInline,
        clickable = _this$props.clickable,
        color = _this$props.color,
        noMarginTop = _this$props.noMarginTop,
        _this$props$popoverPr = _this$props.popoverProps,
        popoverProps = _this$props$popoverPr === void 0 ? {} : _this$props$popoverPr,
        disabled = _this$props.disabled,
        displayToSide = _this$props.displayToSide,
        style = _this$props.style,
        rest = _objectWithoutPropertiesLoose(_this$props, ["className", "content", "children", "icon", "isPopover", "isButton", "size", "isInline", "clickable", "color", "noMarginTop", "popoverProps", "disabled", "displayToSide", "style"]);

    var IconToUse = isButton ? Button : Icon;
    var iconProps = {
      icon: icon,
      color: color,
      disabled: disabled
    };
    if (!isButton) iconProps.iconSize = size;
    var IconInner = /*#__PURE__*/React.createElement(IconToUse, _extends({}, iconProps, rest));
    var toReturn;

    var toolTipOrPopoverProps = _extends({
      disabled: disabled || !isPopover && window.Cypress,
      popoverClassName: "tg-info-helper-popover bp3-tooltip",
      content: content || children,
      modifiers: popoverOverflowModifiers
    }, popoverProps);

    if (displayToSide) {
      toReturn = /*#__PURE__*/React.createElement(React.Fragment, null, IconInner, /*#__PURE__*/React.createElement("span", {
        style: {
          paddingLeft: 5,
          fontStyle: "italic"
        }
      }, content || children));
    } else if (isPopover) {
      toReturn = /*#__PURE__*/React.createElement(Popover, _extends({}, toolTipOrPopoverProps, {
        target: IconInner
      }));
    } else {
      toReturn = /*#__PURE__*/React.createElement(Tooltip, _extends({}, toolTipOrPopoverProps, {
        target: IconInner
      }));
    }

    var El = isInline ? "span" : "div";
    return /*#__PURE__*/React.createElement(El, {
      style: _extends({}, clickable ? {
        cursor: "pointer"
      } : {}, isInline ? {} : {
        display: "flex"
      }, style),
      className: classnames("info-helper-wrapper", {
        "info-helper-wrapper-noMarginTop": noMarginTop,
        "info-helper-clickable": isPopover
      }, className)
    }, toReturn);
  };

  return InfoHelper;
}(Component);

export { InfoHelper as default };